<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Srikung"
      title="Srikung Customer Relation Management"
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'หน้าแรก',
            icon: 'ni ni-tv-2 text-primary',
            path: '/dashboard',
          }"
          :class="lvl != 999 && lvl != 0 ? 'none' : ''"
        />
        <sidebar-item
          :link="{
            name: 'ข้อมูลลูกค้า พรบ',
            icon: 'ni ni-bullet-list-67 text-green',
            path: '/customerWsu',
          }"
        />
        <sidebar-item
          :link="{
            name: ' -  บันทึกข้อมูลใหม่',
            icon: '',
            path: '/customerWsuAddNew',
          }"
          :class="lvl != 999 && lvl != 0 ? 'none' : ''"
        />
        <sidebar-item
          :link="{
            name: ' -  ดุใบเตือนต่ออายุ',
            icon: '',
            path: '/customerWsuReminder',
          }"
        />
        <sidebar-item
          :link="{
            name: 'ข้อมูลลูกค้า ประกัน',
            icon: 'ni ni-bullet-list-67 text-yellow',
            path: '/customerInsurance',
          }"
        />
        <sidebar-item
          :link="{
            name: ' -  ประวัติการแจ้งงาน',
            icon: '',
            path: '/customerInsuranceHistory',
          }"
          :class="lvl != 999 && lvl != 0 ? 'none' : ''"
        />
        <sidebar-item
          :link="{
            name: ' -  ดุใบเตือนต่ออายุ',
            icon: '',
            path: '/customerInsuranceReminder',
          }"
        />
        <sidebar-item
          :link="{
            name: 'แจ้งงาน',
            icon: 'ni ni-collection text-black',
            path: '/line',
          }"
          :class="lvl != 999 && lvl != 0 ? 'none' : ''"
        />
        <sidebar-item
          :link="{
            name: 'ใบเสร็จรับเงิน',
            icon: 'ni ni-single-copy-04 text-orange',
            path: '/receipt',
          }"
          :class="lvl != 999 && lvl != 0 ? 'none' : ''"
        />
        <sidebar-item
          :link="{
            name: 'คำนวนภาษี',
            icon: 'ni ni-tag text-red',
            path: '/calculator',
          }"
          :class="lvl != 999 && lvl != 0 ? 'none' : ''"
        />
        <sidebar-item
          :link="{
            name: 'เอกสารสำเนาลูกค้า',
            icon: 'ni ni-image text-blue',
            path: '/document',
          }"
          :class="lvl != 999 && lvl != 0 ? 'none' : ''"
        />
        <!-- <sidebar-item
          :link="{
            name: 'ตัวแทน',
            icon: 'ni ni-circle-08 text-danger',
            path: '/agent',
          }"
          :class="lvl != 999 ? 'none' : ''"
        /> -->
        <sidebar-item
          :link="{
            name: 'ตัวแทน',
            icon: 'ni ni-circle-08 text-black',
            path: '/agent',
          }"
          :class="lvl != 999 ? 'none' : ''"
        />
        <sidebar-item
          :link="{
            name: 'พนักงาน',
            icon: 'ni ni-single-02 text-pink',
            path: '/employee',
          }"
          :class="lvl != 999 ? 'none' : ''"
        />
        <sidebar-item
          :link="{
            name: 'ประวัติ',
            icon: 'ni ni-chart-bar-32 text-green',
            path: '/logs',
          }"
          :class="lvl != 999 ? 'none' : ''"
        />
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    DashboardNavbar,
    FadeTransition,
  },
  data() {
    return {
      lvl: 0,
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  created: function() {
    this.lvl = localStorage.level;
  },
};
</script>
<style lang="scss">
.none {
  display: none !important;
}
</style>
